import {Children} from 'react';

import {Row} from '../row/Row';

export const Logo = () => (
  <Row spacing={0.75}>
    {Children.toArray([<img alt="logo" width="150px" src="https://edu.devmind.ro/_media/wiki/logo.png" />])}
  </Row>
);
